import NBType from '@netbase/nb-type'
import AlertDayOfMonth from '../enums/AlertDayOfMonth'
import AlertDayOfWeek from '../enums/AlertDayOfWeek'
import AlertFrequency from '../enums/AlertFrequency'
import AlertSubscriptionSchema from './AlertSubscriptionSchema'
import AlertType from '../enums/AlertType'
import AnalysisCategory from '../enums/AnalysisCategory'
import MeasureType from '../enums/MeasureType'
import DashboardColorMode from '../enums/DashboardColorMode'

/**
 * @typedef {import('../enums/AlertDayOfMonth').AlertDayOfMonth} AlertDayOfMonth
 * @typedef {import('../enums/AlertDayOfWeek').AlertDayOfWeek} AlertDayOfWeek
 * @typedef {import('../enums/AlertFrequency').AlertFrequency} AlertFrequency
 * @typedef {import('./AlertSubscriptionSchema').AlertSubscription} AlertSubscription
 * @typedef {import('../enums/AlertType').AlertType} AlertType
 * @typedef {import('../enums/AnalysisCategory').AnalysisCategory} AnalysisCategory
 * @typedef {import('../enums/MeasureType').MeasureType} MeasureType
 * @typedef {import('../enums/DashboardColorMode').DashboardColorMode} DashboardColorMode
 */

/**
 * @typedef {object} AlertSchema
 * @property {number} alertHourFirst
 * @property {number} alertHourSecond
 * @property {number} alertId
 * @property {AnalysisCategory} category
 * @property {number} createDate
 * @property {AlertDayOfMonth} dayOfMonth
 * @property {AlertDayOfWeek} dayOfWeek
 * @property {boolean} debug
 * @property {boolean} debugMoreSb
 * @property {AlertFrequency} frequency
 * @property {number} lastBucketEndTime
 * @property {number} lastErrorCode
 * @property {number} lastErrorUpdateTime
 * @property {number} lastRunDate
 * @property {number} lastTopicIndexEndDate
 * @property {MeasureType} measure
 * @property {number} retryCount
 * @property {AlertSubscription[]} subscribers
 * @property {number} triggeredAlertStamina
 * @property {number} triggeredAlertStrength
 * @property {AlertType} type
 * @property {number} updateDate
 * @property {number} userConfirmTime
 * @property {number} value
 * @property {DashboardColorMode} colorMode
 */
const AlertSchema = NBType.object().shape('AlertSchema', {
  /* @prop */
  alertHourFirst: NBType.number(),
  /* @prop */
  alertHourSecond: NBType.number(),
  /* @prop */
  alertId: NBType.number(),
  /* @prop */
  category: NBType.enum(AnalysisCategory),
  /* @prop */
  createDate: NBType.timestamp(),
  /* @prop */
  dayOfMonth: NBType.enum(AlertDayOfMonth),
  /* @prop */
  dayOfWeek: NBType.enum(AlertDayOfWeek),
  /* @prop */
  debug: NBType.boolean(),
  /* @prop */
  debugMoreSb: NBType.boolean(),
  /* @prop */
  frequency: NBType.enum(AlertFrequency),
  /* @prop */
  lastBucketEndTime: NBType.timestamp(),
  /* @prop */
  lastErrorCode: NBType.number(),
  /* @prop */
  lastErrorUpdateTime: NBType.timestamp(),
  /* @prop */
  lastRunDate: NBType.timestamp(),
  /* @prop */
  lastTopicIndexEndDate: NBType.timestamp(),
  /* @prop */
  measure: NBType.enum(MeasureType),
  /* @prop */
  retryCount: NBType.number(),
  /* @prop */
  subscribers: NBType.array().of(AlertSubscriptionSchema),
  /* @prop */
  triggeredAlertStamina: NBType.number(),
  /* @prop */
  triggeredAlertStrength: NBType.number(),
  /* @prop */
  type: NBType.enum(AlertType),
  /* @prop */
  updateDate: NBType.timestamp(),
  /* @prop */
  userConfirmTime: NBType.timestamp(),
  /* @prop */
  value: NBType.number(),
  /* @prop */
  colorMode: NBType.enum(DashboardColorMode)
  /* END */
})
export default AlertSchema
// RESERVE BELOW
